import React from 'react';
import { Autocomplete, TextField } from '@biq/apex-ui';
import { InputAdornment, Typography } from '@mui/material';
import { walletsAndGroupsCommonStyles } from 'pages/wallets-and-groups/wallets-and-groups-helper';
import { Controller } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';

interface AutocompleteUserGroupFieldProps {
    name: string;
    control: any;
    label?: string;
    fieldValue: any;
    error: any;
    options: { name: string; id: string }[];
    onChange: (value: any) => void;
    handleUnsavedChanges?: () => void;
}

export const AutocompleteUserGroupField = ({
    name,
    control,
    label = '',
    fieldValue,
    error,
    options,
    onChange,
    handleUnsavedChanges,
}: AutocompleteUserGroupFieldProps): React.JSX.Element => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }): React.JSX.Element => (
                <Autocomplete
                    {...field}
                    options={options}
                    getOptionLabel={(option): string => option.name}
                    onChange={(__, value, reason): void => {
                        if (reason === 'clear') {
                            onChange({ name: '', id: '' });
                            return;
                        }
                        field.onChange(value);
                        handleUnsavedChanges?.();
                    }}
                    renderOption={(props, option): any => (
                        <Typography
                            component={'li'}
                            {...props}
                            aria-selected={option.id === fieldValue.id}
                            sx={
                                walletsAndGroupsCommonStyles.autocompleteOptionsStyles
                            }
                        >
                            {option.name}
                        </Typography>
                    )}
                    sx={walletsAndGroupsCommonStyles.autoCompleteStyles}
                    renderInput={(params): React.JSX.Element => (
                        <TextField
                            {...params}
                            size='medium'
                            variant='outlined'
                            label={label}
                            required
                            error={!!error}
                            errorText={error ? error.name?.message : ''}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: [
                                    <InputAdornment
                                        key={'searchIcon'}
                                        position='start'
                                    >
                                        <SearchIcon />
                                    </InputAdornment>,
                                    params.InputProps.startAdornment
                                        ? params.InputProps.startAdornment
                                        : [],
                                ],
                            }}
                        />
                    )}
                />
            )}
        />
    );
};
